module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-14.a882b437.png";